export default __webpack_public_path__ + "static/media/88@2x-8.4dab1d08.png";